import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './UserSummaryCard.styled';
import { CopyButton } from '@/components/CopyButton';
import { formatNumber, formatPhoneNumber } from '@/utils/helpers';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { useCurrentUser } from '@/features/Profile/core/hooks';

export function UserSummaryCard() {
  const { t } = useTranslation();
  const { loading, user } = useCurrentUser();

  return (
    <S.Card>
      <S.Avatar $avatarUrl={user.avatarUrl} />
      <S.UserInfoContainer>
        {user.name && <S.UserName>{user.name}</S.UserName>}
        {user.id && (
          <S.Meta as="div">
            <S.UserId>
              ID: {user.id}
              <CopyButton
                value={user.id}
                successText={t('pages.cabinet.profile_number_copied')}
              />
            </S.UserId>
          </S.Meta>
        )}
        {user.phone && (
          <S.Meta>
            {t('pages.cabinet.tel')} {formatPhoneNumber(user.phone)}
          </S.Meta>
        )}
      </S.UserInfoContainer>

      <S.Balance>
        <div>
          <S.BalanceLabel>{t('pages.cabinet.private_account')}</S.BalanceLabel>
          {loading ? (
            <SkeletonLoader width={80} height={22} borderRadius={7} />
          ) : (
            <S.BalanceValue>
              {formatNumber(user.walletBalance, 2)} ₼
            </S.BalanceValue>
          )}
        </div>
        <S.BalanceButton appearance="secondary" borderRadius={14}>
          {t('pages.cabinet.add')}
        </S.BalanceButton>
      </S.Balance>
    </S.Card>
  );
}
